interface DownloadReportOptions {
  filename: string;
  type?: 'pdf' | 'excel';
}

export const FILE_MIME_TYPES = {
  excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pdf: 'application/pdf',
} as const;

export const downloadReport = (
  data: Blob | ArrayBuffer | string | undefined,
  { filename, type = 'excel' }: DownloadReportOptions,
) => {
  if (!data) {
    throw new Error('No file data provided.');
  }

  if (typeof data === 'string') {
    window.open(data, '_blank', 'noopener,noreferrer');

    return;
  }

  const mimeType = FILE_MIME_TYPES[type];

  const blob =
    data instanceof Blob
      ? data
      : new Blob([data], {
          type: mimeType,
        });

  const fileUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');

  anchor.href = fileUrl;
  anchor.download = filename;
  anchor.style.display = 'none';

  document.body.appendChild(anchor);
  anchor.click();

  document.body.removeChild(anchor);
  setTimeout(() => {
    /**
     * Delay na revoke p/ evitar download issues
     * em alguns browsers (especialmente no Safari)
     */
    window.URL.revokeObjectURL(fileUrl);
  }, 100);
};
